module.exports = __webpack_public_path__ + "static/media/test-rak.df7008e4.jpg";